<ix-layout-grid class="h-100 d-flex flex-column">
  <ix-row>
    <ix-col size="12">
      <ix-content-header
        [headerTitle]="'um.menu_access_request' | translate"
        id="listAccessRequestsHeader"
        [hasBackButton]="false">
      </ix-content-header>
    </ix-col>
  </ix-row>

  @if (loading) {
    <ix-row>
      <ix-col class="d-flex flex-row justify-content-center">
        <ix-spinner size="large"></ix-spinner>
      </ix-col>
    </ix-row>
  }

  @if (!loading) {
    <ix-row class="flex-grow-1">
      @if (accessRequests.length > 0) {
        <ix-col class="h-100 overflow-auto" size="12">
          <ag-grid-angular
            (gridReady)="onGridReady($event)"
            (rowClicked)="onRowClicked($event)"
            [columnDefs]="columnDefs"
            [gridOptions]="gridOptions"
            [rowData]="accessRequests"
            [suppressCellFocus]="true"
            class="w-100 h-100 cursor-pointer"
            id="listAccessRequestsTable">
          </ag-grid-angular>
        </ix-col>
      }
      @if (accessRequests.length === 0) {
        <ix-col size="12">
          <ix-empty-state
            [header]="'um.access_requests.empty_header' | translate"
            [subHeader]="'um.access_requests.empty_sub_header' | translate"
            icon="user">
          </ix-empty-state>
        </ix-col>
      }
    </ix-row>
  }
</ix-layout-grid>
